import { FieldProps, getIn } from 'formik';
import { Checkbox, FormControlLabel, FormHelperText, SxProps, Theme, Typography } from '@mui/material';
import { IOption } from '@shared/interfaces';
import { LabelText } from '@styles/StyledTypography';
import { RelativeWrapper } from '../styledComponents';

export interface ICheckboxListFieldProps extends FieldProps {
  disabled?: boolean;
  options: IOption[];
  checked?: string | number | boolean;
  label?: string;
  nextLine?: boolean;
  sx?: SxProps<Theme>;
  onChange?(value: string): void;
}

export const CheckboxListField = ({
  field,
  form,
  disabled: _disabled,
  options,
  label,
  nextLine = false,
  ...props
}: ICheckboxListFieldProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  const checkedIndex = (value: unknown) => {
    return Array.isArray(field.value) ? field.value.findIndex((item) => item === value) : -1;
  };

  const onChange = (value: unknown) => {
    const index = checkedIndex(value);
    let selected = [...field.value];

    if (index >= 0) {
      selected.splice(index, 1);
    } else {
      selected = [...field.value, value];
    }

    form.setFieldTouched(field.name);
    form.setFieldValue(field.name, selected);
  };

  const labelSx = nextLine ? { width: '100%', height: 'auto' } : {};

  return (
    <RelativeWrapper>
      {label && (
        <Typography
          variant="h6"
          sx={{ fontSize: '12px', fontWeight: 'bold' }}
        >
          {label}
        </Typography>
      )}
      {options?.map((option, index) => (
        <FormControlLabel
          key={index}
          label={<LabelText wrap>{option.label}</LabelText>}
          sx={labelSx}
          control={
            <Checkbox
              {...props}
              name={option.label}
              disabled={option.disabled}
              checked={checkedIndex(option.value) >= 0}
              sx={option.sx}
              onChange={() => onChange(option.value)}
            />
          }
        />
      ))}

      {error && touched && <FormHelperText error>{error}</FormHelperText>}
    </RelativeWrapper>
  );
};
